import { AlpineComponent } from "alpinejs";

type ClipboardComponent = AlpineComponent<{
	copy: (text: string) => Promise<void>;
	isCopying: boolean;
}>;

export default (): ClipboardComponent => {
	return {
		async copy(text: string) {
			try {
				this.isCopying = true;
				await navigator.clipboard.writeText(text);
			} catch (err) {
				console.error("Failed to copy text: ", err);
			} finally {
				setTimeout(() => {
					this.isCopying = false;
				}, 3000);
			}
		},
		isCopying: false,
	};
};
